import React from "react";
import { Col, Container, Row } from "reactstrap";

const Section = () => {
  return (
    <React.Fragment>
      {/* <!-- START HOME --> */}
      <section className="bg-home" id="home">
        <div className="bg-overlay"></div>
        <Container>
          <Row className="align-items-center">
            <Col lg={7}>
              <div className="home-content me-lg-5 text-center text-lg-start">
                <h6 className="sub-title mb-3 text-white">Energia Renovável para um Futuro Sustentável</h6>
                <h1 className="mb-4 text-white">
                  Reduza até <span className="text-primary">95%</span> da sua conta de luz com{" "}
                  <span className="text-primary">Energia Solar</span>
                </h1>
                <p className="text-white-50 fs-17">
                  A Araucária Solar é especialista em soluções de energia fotovoltaica para
                  residências, comércios e indústrias. Com mais de 6 anos de experiência,
                  oferecemos projetos personalizados com a melhor relação custo-benefício do mercado.
                </p>
                <div className="mt-4">
                  <a href="#contato" className="btn btn-primary mt-2">
                    Solicite um Orçamento
                  </a>{" "}
                  <a href="#quem-somos" className="btn btn-outline-white mt-2 ms-md-1">
                    Conheça a Araucária Solar
                  </a>
                </div>
              </div>
            </Col>
            <Col lg={5}>
              <div className="home-stats mt-4 mt-lg-0 text-center text-lg-end">
                <div className="stat-item mb-4">
                  <h2 className="text-primary mb-0 display-4 fw-bold">+500</h2>
                  <p className="text-white-50 mb-0">Projetos Realizados</p>
                </div>
                <div className="stat-item mb-4">
                  <h2 className="text-primary mb-0 display-4 fw-bold">6+</h2>
                  <p className="text-white-50 mb-0">Anos de Experiência</p>
                </div>
                <div className="stat-item">
                  <h2 className="text-primary mb-0 display-4 fw-bold">2MW+</h2>
                  <p className="text-white-50 mb-0">Potência Instalada</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* <!-- END HOME --> */}
      {/* <!-- START SHAPE --> */}
      <div className="position-relative">
        <div className="shape">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="1440"
            height="150"
            preserveAspectRatio="none"
            viewBox="0 0 1440 150"
          >
            <g mask='url("#SvgjsMask1022")' fill="none">
              <path
                d="M 0,58 C 144,73 432,131.8 720,133 C 1008,134.2 1296,77.8 1440,64L1440 250L0 250z"
                fill="rgba(255, 255, 255, 1)"
              ></path>
            </g>
            <defs>
              <mask id="SvgjsMask1022">
                <rect width="1440" height="250" fill="#ffffff"></rect>
              </mask>
            </defs>
          </svg>
        </div>
      </div>
      {/* <!-- END SHAPE --> */}
    </React.Fragment>
  );
};

export default Section;
